export default {
  web: {
    footer: {
      product: "Produto",
      company: "Empresa",
      download: "Download",
      pricing: "Preços",
      bonuses: "Bônus",
      copyright: "Todos os direitos reservados.",
    },
  },
};
